import { Typography } from "@packages/ds";
import styled from "styled-components";

import { ButtonWrapper } from "ds/Button";

export const ButtonContainer = styled(ButtonWrapper)`
  margin-top: 40px;
`;

export const DeployementSectionLabel = styled(Typography.Label)`
  margin-bottom: 10px;
  font-size: var(--fs-m);
  color: var(--mode-text-neutral-weak);
  line-height: 24px;
`;

export const DeploymentTypeLabel = styled(Typography.Label)`
  color: var(--mode-text-neutral-default);
  font-size: var(--fs-m);
  line-height: 24px;
`;

export const DeploymentTypeDescription = styled(Typography.BodyText)`
  color: var(--mode-text-neutral-weakest);
`;

export const DeploymentTypeWrapper = styled.div``;

export const SettingWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ErrorWrapper = styled.div`
  padding: 16px 0;
`;

export const AutomaticDeploymentDescription = styled(Typography.BodyText)`
  margin-left: 28px;
`;
